import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useModal } from '@jutro/components';
import { withRouter } from 'react-router-dom';
import metadata from './AdditionalInterestDetails.metadata.json5';
import messages from './AdditionalInterestDetails.messages';

function AdditionalInterestDetails(props) {
    const {
        submissionVM,
        updateWizardData,
        pathUpdated,
        listofAdditionalInterest,
    } = props;

    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('AdditionalInterestDetails');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();

    modelVM.isValidationReq.value = true
    modelVM.isPropertyInStorage.value = submissionVM.value.lobData.perLine.selectedOffering_Ext === 'PerProInSto'

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    const deleteAdditionalInterest = useCallback(
        () => {
            const infoListPath = `${listofAdditionalInterest}.value`;
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [listofAdditionalInterest, modelVM.value, submissionVM, showConfirm, updateWizardData]
    );

    const getInTypPath = useCallback(() => {
        if (_.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') === 'PerProInSto') {
            return 'intTypFiePropInSto'
        }

        return 'intTypFie'

    }, [submissionVM.value])

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        additionalAccordionSet: {
            path: ''
        },
        intTypFie: {
            path: getInTypPath()
        },
        covTypFie: {
            visible: _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') === 'PerProInSto',
            required: _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') === 'PerProInSto'
        },
        arrAmoFie: {
            visible: _.get(modelVM.value, 'arrFie') === true
        },
        wriNotDayFie: {
            visible: _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') !== 'TinHom' && _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') !== 'MobHom'
        },
        wriNotDayFie1: {
            visible: _.get(submissionVM.value, 'lobData.perLine.selectedOffering_Ext') === 'TinHom'
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate,
            deleteAdditionalInterest
        },
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );
}

AdditionalInterestDetails.propTypes = wizardProps;
export default withRouter(AdditionalInterestDetails);